export default __webpack_public_path__ + "static/media/f_md-8.8debba74.svg";